<template>
    <div class="firm-group">
        <b-row>
            <csp-desktop-firm-group-basedata :cols="12" :form-context="initialFormContexts.firmGroupBasedata"
                :is-creation-form="true"/>
        </b-row>
    </div>
</template>

<script>
    import FirmGroupBasedata from '@desktop/components/firmGroup/detail/FirmGroupBasedata.vue';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import FormContext from '@desktop/components/FormContext';
    import Container from '@services/Container';

    const container = Container.getInstance();
    const firmGroupRepository = container.getDesktopFirmGroupRepository();

    export default {
        name: 'FirmGroupCreate',
        components: {
            'csp-desktop-firm-group-basedata': FirmGroupBasedata,
        },
        mixins: [FormDataMixin],
        data() {
            return {
                initialFormContexts: {
                    firmGroupBasedata: new FormContext({
                        name: 'firmGroupBasedata',
                        isAlwaysInEditMode: true,
                    }),
                },
            };
        },
        created() {
            const loadFunction = () => {
                return firmGroupRepository.getBlank();
            };
            this.loadFormData(loadFunction);
        },
    }
</script>
